import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  padding: 15px;
`;

// WrapperInner
export const WrapperInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 800px;
  margin: 0px auto;
  padding: 40px 20px 20px 20px;
  background-color: #f9f9f9;
  border-radius: 10px;
`;

// balance
export const Balance = styled.div`
  margin-bottom: 20px;
  margin-top: 0;
  color: #212121;

  p {
    margin-bottom: 5px;
  }

  h2 {
    margin: 0;
    font-weight: bold;
    font-size: 2em;
    line-height: 1.1;
  }
`;

// TransHeader
export const TransHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;

  h4 {
    margin: 0;
    font-weight: 600;
    font-size: 1.25em;
    line-height: 1.1;
  }
`;

// back button
export const Button = styled.button`
  background-color: #ffffff;
  cursor: pointer;
  font-size: 16px;
  color: #212121;
  padding: 10px 20px;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 10px;

  &:hover {
    background-color: #f9f9f9;
    border: 1px solid rgb(63, 63, 63);
  }

  &:disabled {
    cursor: not-allowed !important;
    opacity: 0.5;
  }
`;

// Refresh Button
export const RefreshButton = styled.button`
  background-color: #ffffff;
  cursor: pointer;
  font-size: 16px;
  color: #212121;
  padding: 10px 12px;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 10px;

  &:hover {
    background-color: #f9f9f9;
    border: 1px solid rgb(63, 63, 63);
  }

  &.loading {
    svg {
      animation: spin 1s linear infinite;

      @keyframes spin {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
    }
  }
`;

// table wrapper
export const TableWrapper = styled.div`
  overflow-x: auto;
`;

// Table
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  thead {
    background-color: #fff;
    color: #212121;
  }

  tr {
    background-color: #fff;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #f9f9f9;
    }

    td:first-child {
      white-space: nowrap;
    }
  }

  th,
  td {
    padding: 12px 10px;
    text-align: left;
    border: 1px solid #f9f9f9;

    &:last-child {
      text-align: right;
      font-weight: 600;
    }
    
    &.credit {
      color: #4CAF50;
    }
    
    &.debit {
      color: #f44336;
    }
`;

// tranfooter
export const TransFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

// pagination
export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

export const SelectWrapper = styled.div`
  position: relative;
  display: inline-block;

  &::after {
    content: '▼';
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    pointer-events: none;
    font-size: 12px;
    color: #555;
  }
`;

export const Select = styled.select`
  width: 100%;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  color: #212121;
  padding: 10px 25px 10px 10px;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  outline: none;
  transition: border ease-in-out 0.15s, box-shadow ease-in-out 0.15s;

  &:hover {
    border: 1px solid rgb(63, 63, 63);
  }
`;

// input
export const Input = styled.input`
  width: 100%;
  padding: 10px 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin-bottom: 0px;
  resize: vertical;
  background: #fff;
  cursor: auto;
  outline: none;
  transition: border ease-in-out 0.15s, box-shadow ease-in-out 0.15s;

  &:focus,
  &:hover {
    border: 1px solid rgb(63, 63, 63);
    background: #f9f9f9;
  }
`;

// empty state
export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 40px;
  text-align: center;
  margin-bottom: 40px;
  
  p {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    text-align: center;

    svg {
      animation: spin 1s linear infinite;

      @keyframes spin {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(360deg);
        }
      }
    }
  }
`;

// status badge
export const StatusBadge = styled.span`
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  border: 1px solid #ccc;
  background-color: #4caf5020;
  color: #4caf50;

  &.settled {
    background-color: #4caf5020;
    color: #4caf50;
    border-color: #4caf5050;
  }

  &.failed {
    background-color: #f4433620;
    color: #f44336;
    border-color: #f4433650;
  }

  &.pending {
    background-color: #ff980020;
    color: #ff9800;
    border-color: #ff980050;
  }
`;

// daterange wrapper
export const DateRangeWrapper = styled.div`
  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
    position: relative;
    background-color: ${({ theme }) => theme.brand.primary} !important;
    color: #f0f8ff;
  }
`;
